export default __webpack_public_path__ + "static/media/flow.eb076063.png";